
































































import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import Publish from "@/views/Intro/Publish.vue";
import Footer from "@/components/Footer.vue";
@Component({
  components: {
    Header,
    Menu,
    Publish,
    Footer
  }
})
export default class WhoAmI extends Vue {}
